/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-header[_ngcontent-%COMP%]{position:fixed;width:100%;z-index:20;top:0;-webkit-transition:.2s ease-in-out;transition:all .2s ease-in-out}.content[_ngcontent-%COMP%]{background:#fff;font-family:'Open Sans',Arial,Helvetica,sans-serif;text-rendering:auto;word-spacing:normal;letter-spacing:normal}"];
export { styles as styles };
